import { updateDoc, doc, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const chooseInterest = async (categ, userId, userData) => {
  const docRef = doc(db, "users", userId);
  // LOCAL VERSION
  //   if (signupForm.values.interests?.includes(categ)) {
  //     signupForm.removeListItem(
  //       "interests",
  //       signupForm.values.interests?.indexOf(categ)
  //     //   display some message
  //     );
  //   } else if (
  //     !signupForm.values.interests?.includes(categ) &&
  //     signupForm.values.interests?.length < 3
  //   ) {
  //     signupForm.insertListItem("interests", categ);
  //   }
  //   console.log(categ);

  // CLOUD VERSION
  if (userData.interests?.includes(categ)) {
    await updateDoc(docRef, {
      interests: arrayRemove(categ),
    });
    // display a message
  } else if (
    !userData.interests?.includes(categ) &&
    userData.interests?.length < 3
  ) {
    await updateDoc(docRef, {
      interests: arrayUnion(categ),
    });
  }
};

export default chooseInterest;
